export default function Artists() {
  const artists = [
    {
      name: 'Grupo Aroma',
      genre: 'Música Regional',
      image: 'https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/db0cad26e79f48d70f8c160a7cb0bc2d.jpeg',
      description: 'Grupo musical femenino con gran energía y talento, especializado en música regional mexicana y cumbia.'
    },
    {
      name: 'Los Reyes del Norte',
      genre: 'Banda Sinaloense',
      image: 'https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/85b03143be07937ec75e739bb071b797.jpeg',
      description: 'Banda sinaloense con más de 10 años de trayectoria, perfecta para bodas y eventos especiales.'
    },
    {
      name: 'Luis Angel',
      genre: 'Cantante Solista',
      image: 'https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/0e7f812e46882e1a8c765a7cd093dd8b.jpeg',
      description: 'Voz versátil que interpreta desde baladas románticas hasta música pop y regional.'
    },
    {
      name: 'Mariachis - Marimbas',
      genre: 'Música de Mariachi',
      image: 'https://static.readdy.ai/image/05c85fc7da3c56350a98e06d6933007c/4b5b957452247fc01ba0e541a8b7b653.jpeg',
      imagePosition: 'object-left',
      description: 'Mariachi tradicional que lleva la auténtica música mexicana a cada celebración.'
    },
    {
      name: 'DJ Sonic',
      genre: 'Música Electrónica',
      image: 'https://public.readdy.ai/ai/img_res/10234886eb2b2690044fa7ec42d58232.jpg',
      description: 'DJ profesional especializado en fiestas, bodas y eventos corporativos con música variada.'
    },
    {
      name: 'Cumbia Kings',
      genre: 'Cumbia y Tropical',
      image: 'https://readdy.ai/api/search-image?query=energetic%20tropical%20cumbia%20music%20band%20wearing%20colorful%20festive%20outfits%20with%20percussion%20instruments%20congas%20and%20timbales%20dancing%20and%20performing%20on%20a%20clean%20gradient%20background%20from%20soft%20pink%20to%20white%20joyful%20party%20atmosphere&width=800&height=1000&seq=artist-006&orientation=portrait',
      description: 'Grupo especializado en cumbia, salsa y música tropical para animar cualquier fiesta.'
    }
  ];

  return (
    <section id="artistas" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="font-['Montserrat',sans-serif] text-4xl sm:text-5xl font-bold text-gray-900 mb-4">
            Nuestros Artistas
          </h2>
          <p className="font-['Poppins',sans-serif] text-base text-gray-600 max-w-2xl mx-auto">
            Talento profesional de primer nivel para hacer de tu evento una experiencia memorable
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {artists.map((artist, index) => (
            <div 
              key={index}
              className="group bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
            >
              <div className="relative w-full h-96 overflow-hidden">
                <img 
                  src={artist.image}
                  alt={artist.name}
                  className={`w-full h-full object-cover ${artist.imagePosition || 'object-top'} group-hover:scale-110 transition-transform duration-500`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="inline-block bg-teal-600 text-white text-xs font-semibold px-3 py-1 rounded-full mb-3">
                    {artist.genre}
                  </span>
                  <h3 className="font-['Montserrat',sans-serif] text-2xl font-bold text-white mb-2">
                    {artist.name}
                  </h3>
                </div>
              </div>
              <div className="p-6">
                <p className="font-['Poppins',sans-serif] text-sm text-gray-600 leading-relaxed">
                  {artist.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
